export default __webpack_public_path__ + "static/media/global-care.e4fc7ef6.jpg";